import { AllCommunityModule, ModuleRegistry, ColDef } from "ag-grid-community";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";

import { toast } from "sonner";
import { useQueryState } from "nuqs";

import { getClassById } from "../../../api/pedagogicElement";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import myTheme, { getColumnColor } from "../../../style/agGridTheme/theme";

import {
  createNote,
  deleteStudentNote,
  generateStudentCertificate,
  getStudentNoteByMatiere,
  getSubjectAverages,
  updateStudentNote,
} from "../../../api/notes";

import { getAllUEByPeriod } from "../../../api/ue";
import { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { Link } from "react-router";
import { getAllStudentByClass, getStudentById } from "../../../api/etudiants";
import { getStudentArchivesById } from "../../../api/archives";
import { getAllEvaluationPeriodByLevel } from "../../../api/generalParam";
import { getMethodByYear } from "../../../api/settings";
import { getAllEvaluationByPeriodAndLevel } from "../../../api/evaluations";
import EditableCellRenderer, { navigateToEditableCellOnArrow } from "../editableCellRender";

import { generateStudentNoteReleve } from "../../../api/notes";
import ReleveModalApercu from "./releveModalApercu";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";

import CertificatModalApercu from "./attestationModal";
import DiplomeModal from "./diplomeModal";
import StudentNoteStatistique from "./StudentNoteStatistique";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import { usePermissions } from "../../../core/common/context/PermissionsUserContext";
import withPermission from "../../../core/common/autorisations/withPermission";
import { useSelector } from "react-redux";
import { getStudentParcours } from "../../../api/parcours";
import CheckStudentEligibilityModal from "./CheckStudentEligibilityModal";
import { set } from "zod";

type PendingNoteChange = {
  type: "create" | "update" | "delete";
  noteId?: string;
  payload: any;
};

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

interface Note {
  id?: string;
  __pendingCreate?: boolean;
  __pendingUpdate?: boolean;
  __pendingDelete?: boolean;
  EvaluationLevel?: any;
  id_evaluation: string;
  value?: number | string;
  commentaire?: string;
  key?: number;
}
interface CustomColDef extends ColDef {
  evaluationId?: string; // ID de l'évaluation
  evaluationLevelId?: string; // ID du niveau d'évaluation
  subjectUEId?: string; // ID de l'UE de la matière
}

// condition pour vérifier si droit d'édition ou pas
const canEdit = (permissions: string[], isSuperAdmin: boolean): boolean => {
  return (
    [
      buildPermission(Resource.NOTE, Action.CREATE),
      buildPermission(Resource.NOTE, Action.UPDATE),
      buildPermission(Resource.NOTE, Action.DELETE),
    ].some((requiredPerm: any) => permissions.includes(requiredPerm)) ||
    isSuperAdmin
  );
};

// bouton protégée pour générer un relevé de note
const ProtectedBtnGenerateReleve = withPermission(
  (props: any) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Relevé de notes</Tooltip>}
    >
      {props.isLoading ? (
        <button
          className="dropdown-item d-flex align-items-center"
          disabled
        >
          <div
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></div>
          <span>Génération...</span>
        </button>
      ) : (
        <button
          className="dropdown-item d-flex align-items-center"
          disabled={!props.studentId || !props.selectedPeriod || !props.classe}
          onClick={async () => {
            if (!props.studentId || !props.selectedPeriod || !props.classe)
              return;
            props.setIsLoading(true);
            await props.generateReleve();
            props.setIsLoading(false);
          }}
        >
          <i className="ti ti-file-analytics me-2" />
          <span>Relevé</span>
        </button>
      )}
    </OverlayTrigger>
  ),
  [buildPermission(Resource.RELEVE, Action.CREATE)],
  "masquer",
);

// bouton protégée pour générer une attestation
const ProtectedBtnGenerateAttestation = withPermission(
  (props: any) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Attestation de réussite</Tooltip>}
    >
      {props.isCertificateLoading ? (
        <button
          className="dropdown-item d-flex align-items-center"
          disabled
        >
          <div
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></div>
          <span>Génération...</span>
        </button>
      ) : (
        <button
          className="dropdown-item d-flex align-items-center"
          // disabled={!props.studentId || !props.classe}
          onClick={async () => {
            props.setShowParcours(true);
            // if (!props.studentId || !props.classe) return;
            // props.setIsCertificateLoading(true);
            // await props.generateCertificate();
            // props.setIsCertificateLoading(false);
          }}
        >
          <i className="ti ti-file-certificate me-2" />
          <span>Attestation</span>
        </button>
      )}
    </OverlayTrigger>
  ),
  [buildPermission(Resource.ATTESTATION, Action.CREATE)],
  "masquer",
);

const StudentNoteList = () => {
  // permissions de l'utilisateur connecté
  const { permissions } = usePermissions();
  const isSuperAdmin = useSelector(
    (state: any) => state.auth?.user?.isSuperAdmin,
  );

  const [studentId, setStudentId] = useQueryState("id_student", {
    history: "replace", // ou 'push' si tu veux garder dans l'historique
  });

  const { selectedYear } = useAcademicYear();

  // const [expandedTypeUE, setExpandedTypeUE] = useState<string | null>(null);
  // const [expandedUE, setExpandedUE] = useState<string | null>(null);

  const [isLoading, setIsLoading] = useState(false); // Pour la génération du relevé de notes

  const [isCertificateLoading, setIsCertificateLoading] = useState(false); // Pour la génération du certificat

  const [colDefs, setColDefs] = useState<any[]>([]);
  const [isLoadingGrid, setIsLoadingGrid] = useState(false); // État de chargement du grid
  const [pendingChanges, setPendingChanges] = useState<Record<string, PendingNoteChange>>({});
  const [isSaving, setIsSaving] = useState(false);
  const pendingChangeCount = Object.keys(pendingChanges).length;

  useEffect(() => {
    if (!pendingChangeCount) return;
    const message = "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?";
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
    };
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const link = target?.closest("a[href]") as HTMLAnchorElement | null;
      if (!link || link.target === "_blank" || link.href === window.location.href) return;
      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleLinkClick, true);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleLinkClick, true);
    };
  }, [pendingChangeCount]);

  const [studentData, setStudentData] = useState<any>();
  const [allStudent, setAllStudent] = useState<any[]>([]);
  const [studentNotes, setStudentNotes] = useState<any[]>([]);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);

  const queueNoteChange = (key: string, change: PendingNoteChange) => {
    setPendingChanges((current) => ({ ...current, [key]: change }));
  };

  const savePendingChanges = async () => {
    const changes = Object.values(pendingChanges);
    if (!changes.length) return;
    setIsSaving(true);
    try {
      for (const change of changes) {
        if (change.type === "create") await createNote(change.payload);
        if (change.type === "update") await updateStudentNote(change.noteId || "", change.payload);
        if (change.type === "delete") await deleteStudentNote(change.noteId || "");
      }
      setPendingChanges({});
      toast.success(`${changes.length} changement${changes.length > 1 ? "s" : ""} enregistré${changes.length > 1 ? "s" : ""}`);
      await fetchAllStudentNote();
    } catch (error: any) {
      toast.error(error.response?.data?.message || error.response?.data?.error || error.message || "Impossible d'enregistrer les changements");
    } finally {
      setIsSaving(false);
    }
  };

  const [classe, setClasse] = useState<any>();

  const [allPeriodEvaluation, setAllPeriodEvaluation] = useState<any[]>([]);
  const [selectedPeriod, setSelectedPeriod] = useState<any>();
  const [isLoadingPeriods, setIsLoadingPeriods] = useState(false);

  const [allEvaluation, setAllEvaluation] = useState<any[]>([]);

  // state pour le PDF
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);

  // State pour le PDF et le modal releve de note
  const [showModal, setShowModal] = useState(false);

  // State pour le modal de la seclection du parcours pour l'attestation
  const [showParcours, setShowParcours] = useState(false);
  const [selectedParcours, setSelectedParcours] = useState<any>();

  // State pour le PDF et le modal de certificat/attestation
  const [showModalCertificat, setShowModalCertificat] = useState(false);
  const [pdfBlobUrlCertificat, setPdfBlobUrlCertificat] = useState<
    string | null
  >(null);

  // State pour le PDF et le modal du diplome
  const [showModalDiplome, setShowModalDiplome] = useState(false);
  const [pdfBlobUrlDiplome, setPdfBlobUrlDiplome] = useState<string | null>(
    null,
  );
  const [isNotRegisteredInYear, setIsNotRegisteredInYear] = useState(false);
  const [registrationChecked, setRegistrationChecked] = useState(false);

  const studentOptions = useMemo(
    () =>
      allStudent.map((etudiant) => ({
        label: `${etudiant?.StudentProfil?.firstname} ${etudiant?.StudentProfil?.lastname}`,
        value: String(etudiant?.StudentProfil?.id),
      })),
    [allStudent],
  );

  const periodOptions = useMemo(
    () =>
      allPeriodEvaluation.map((periode) => ({
        label: periode?.label,
        value: String(periode?.id),
      })),
    [allPeriodEvaluation],
  );

  const fetchAllStudent = async () => {
    setIsLoadingStudents(true);
    try {
      if (!classe) {
        setAllStudent([]);
        return;
      }
      const response = await getAllStudentByClass(
        classe?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("all student: ", response.data);
      setAllStudent(response.data);
    } catch (error: any) {
      // console.log("erreur récupération des étudiants ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingStudents(false);
    }
  };

  useEffect(() => {
    fetchAllStudent();
  }, [classe]);

  const fetchStudentData = async () => {
    try {
      if (!studentId) {
        toast.error("Aucun Id étudiant réçu depuis l'URL");
        return;
      }

      const response = await getStudentById(
        studentId,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("student archive: ", response.data);
      const archive = await getStudentArchivesById(
        response.data.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );

      const parcours = await getStudentParcours(
        studentId,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );

      const formatData = {
        student: response.data,
        archive: archive.data,
        parcours: parcours.data?.ParcoursStudents || [],
      };
      setStudentData(formatData);
      // console.log("student data: ", formatData);
    } catch (error: any) {
      // console.log("erreur récupération des infos étudiant ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  useEffect(() => {
    if (!studentId) return;

     // Reset
    setClasse(null);
    setSelectedPeriod(null);
    setRegistrationChecked(false);
    setStudentNotes([]);

    fetchStudentData();
  }, [studentId]);

  const getCurrentClass = async () => {
    if (!studentData) return;
    setRegistrationChecked(false);
    // if (!studentData?.archive) return;
    const classeMatched = studentData?.archive.find(
      (archiveItem: any) => archiveItem?.id_academicYear === selectedYear?.id,
    );
    if (classeMatched) {
      const response = await getClassById(
        classeMatched?.id_class,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // setClasseId(classeMatched?.id_class)
      // console.log("final class fund: ", response.data);
      setClasse({ ...response.data, Level: classeMatched.Class?.Level });
      setIsNotRegisteredInYear(false);
    } else {
      setIsNotRegisteredInYear(true);
      setClasse(null);
      toast.error("Etudiant inscript dans aucune classe de l'année choisie");
    }
    setRegistrationChecked(true);
  };

  useEffect(() => {
  setRegistrationChecked(false);
  setClasse(null);
  setSelectedPeriod(null);
  setStudentNotes([]);
  setIsNotRegisteredInYear(false);

  if (selectedYear && studentData) {
    getCurrentClass();
  }
}, [selectedYear, studentData]);

  const fetchAllPeriod = async () => {
    setIsLoadingPeriods(true);
    setSelectedPeriod(undefined);
    setAllPeriodEvaluation([]);
    try {
      const response = await getAllEvaluationPeriodByLevel(
        classe?.id_level,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      //   console.log("all period evaluation: ", response.data);
      setAllPeriodEvaluation(response.data);

      if (response.data.length > 0) {
        // console.log("select default periode: ", response.data[0]);
        setSelectedPeriod(response.data[0]);
      }
    } catch (error: any) {
      // console.log(
      //   "erreur récupération des périodes évaluation de la classe ",
      //   error,
      // );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingPeriods(false);
    }
  };

  useEffect(() => {
    if (!classe) return;
    fetchAllPeriod();
  }, [classe]);

  // fonction pour récupérerles évaluations
  const fetchAllEvaluation = async () => {
    try {
      if (!selectedPeriod?.id) {
        setAllEvaluation([]);
        setAllPeriodEvaluation([]);
        setAllStudent([]);
        setStudentNotes([]);
        return;
      }
      const response = await getAllEvaluationByPeriodAndLevel(
        classe?.id_level,
        selectedPeriod?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      const methodeCalcul = await getMethodByYear(
        selectedYear?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("methodClacul:", methodeCalcul.data);
      const formatData = response.data.map((evaluationItem: any) => {
        if (evaluationItem.typeNote === "Note Examen")
          return {
            ...evaluationItem,
            weight: methodeCalcul.data[0].weightNoteExamen,
          };
        if (evaluationItem.typeNote === "Note Classe")
          return {
            ...evaluationItem,
            weight: methodeCalcul.data[0].weightNoteClass,
          };
      });
      // console.log("all evaluation:", formatData);
      setAllEvaluation(formatData);
    } catch (error: any) {
      // console.log("erreur récupération des evaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    fetchAllEvaluation();
  }, [selectedPeriod]);

  const fetchAllStudentNote = async () => {
    try {
      if (!classe || !studentId || !selectedPeriod || !selectedYear) return;

      const response = await getAllUEByPeriod(
        classe?.id,
        selectedPeriod?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );

      const allSubj = response.data.map((sub: any) =>
        sub?.SubjectUEs.flat(Infinity),
      );

      // console.log("all student notes: ", response.data);

      // const allSubject: any[] = [];

      const allNotes = await Promise.all(
        allSubj.flat(Infinity).map(async (subjectItem: any) => {
          const res = await getStudentNoteByMatiere(
            studentId,
            subjectItem?.Subject?.id,
            selectedYear?.id,
          );
          const filterNoteBySubject: any[] = res.data.filter(
            (noteItem: any) => noteItem?.id_subjectUE === subjectItem?.id,
          );
          return {
            notes: filterNoteBySubject,
            subject: { ...subjectItem },
          };
        }),
      );

      // console.log("all notes by subject: ", allNotes);
      //       //  regrouper les notes avec les moyennes et mentions
      const formattedAllNote = await Promise.all(
        allNotes.map(async (noteItem: any) => {
          const response = await getSubjectAverages({
            id_studentProfil: studentId,
            id_academicYear: selectedYear?.id,
            id_subject: noteItem?.subject?.Subject?.id,
            id_evaluationPeriod: selectedPeriod?.id,
          });
          const average = response?.results[0];
          return {
            ...noteItem,
            average: average?.average,
            mention: average?.mention,
          };
        }),
      );
      // console.log("formatted all notes: ", formattedAllNote);

      setStudentNotes(
        formattedAllNote.length > 0 ? formattedAllNote : response,
      );
    } catch (error: any) {
      setIsLoadingGrid(false); // Arrêter le chargement en cas d'erreur
      // console.log("erreur récupération des note en fonction des UE ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingGrid(false); // Toujours arrêter le chargement
    }
  };

  useEffect(() => {
    if (!selectedPeriod || isNotRegisteredInYear) return;
      setIsLoadingGrid(true); // Commencer le chargement
    setStudentNotes([]);
    fetchAllStudentNote();
    console.log("REcuperation des notes 1")
  }, [selectedPeriod, classe]);

  // paramètres globaux d'affichage des colonnes
  const defaultColDef = useMemo(() => {
    return {
      filter: true,
      resizable: true,
      sortable: true,
      suppressKeyboardEvent: navigateToEditableCellOnArrow,
    };
  }, []);

  // Fonction pour créer une note
  const createNewNote = async (
    id_studentProfil: string,
    id_subjectUE: string,
    note: Note,
  ) => {
    try {
      const formattedData = {
        id_studentProfil,
        id_evaluationLevel: note?.id_evaluation,
        id_subjectUE,
        value: note?.value,
        commentaire: note.commentaire,
      };
      await createNote(formattedData);
      toast.success("Note attribuer avec succès");
      await fetchAllStudentNote();
    console.log("REcuperation des notes 2")

    } catch (error: any) {
      // console.log("erreur création note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  //Fonction pour éditer une note
  const updateNote = async (id_note: string, payload: any) => {
    try {
      // {commentaire, value, id_studentProfil, id_evaluationLevel, id_subjectUE } payload structure
      await updateStudentNote(id_note, payload);
      toast.success("note mise à jour");
      await fetchAllStudentNote();
    console.log("REcuperation des notes 3")

    } catch (error: any) {
      // console.log("erreur édition note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fonction pour supprimer une note
  const deleteNote = async (id_note: string) => {
    try {
      await deleteStudentNote(id_note);
      toast.success("note supprimée ");
      await fetchAllStudentNote();
    console.log("REcuperation des notes 4")

    } catch (error: any) {
      // console.log("erreur suppression note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fontion pour générer un relevé denotes selon la périod , année academique , la classe et l'étudiant
  const generateReleve = async () => {
    try {
      const response = await generateStudentNoteReleve({
        id_studentProfil: studentId,
        id_academicYear: selectedYear?.id,
        id_evaluationPeriod: selectedPeriod?.id,
        id_class: classe?.id,
      });
      // console.log("releve generation : ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      setShowModal(true);
      // console.log("relevé généré: ", response);
      toast.success("Relevé généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération relevé: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false); // ← Toujours arrêter le chargement à la fin
    }
  };

  // Fonction pour générer une attestation en fonction de l'étudiant, et du cycle
  const generateCertificate = async () => {
    try {
      let response: any = null;

      response = await generateStudentCertificate({
        id_parcoursStudent: selectedParcours,
      });

      if (!response)
        throw new Error(
          "impossible de générer une attestation veuillez réessayer plus tard !",
        );

      // console.log("response certificat generation: ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrlCertificat(url);
      setShowModalCertificat(true);
      toast.success("Certificat généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération diplôme: ", error);

      let errorMessage = "Une erreur s'est produite, réessayez plus tard";

      // Vérifie si on a bien un blob en réponse
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text(); // Convertir blob → texte
          const json = JSON.parse(text); // Parser texte → JSON
          errorMessage = json.error || json.message || errorMessage;
        } catch (parseErr) {
          // console.error("Impossible de parser l'erreur blob :", parseErr);
        }
      } else {
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          errorMessage;
      }

      toast.error(errorMessage);
    } finally {
      setIsCertificateLoading(false);
    }
  };

  // construire les colonnes de nos matieres
  const buildSubjectColumn = () => {
    try {
      const subjectName = {
        field: "subject",
        headerName: `Matières`,
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 150,
        valueGetter: (params: any) =>
          params.data?.subject?.Subject?.label ?? "",
        cellRenderer: (record: any) => {
          // console.log("record: ", record.data);
          return <div>{record?.data?.subject?.Subject?.label || ""}</div>;
        },
      };
      const averageColumn = {
        field: "average",
        headerName: `Moyenne`,
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 150,
        valueGetter: (params: any) => params.data?.average ?? "",
        cellRenderer: (record: any) => <div>{record?.data?.average || ""}</div>,
      };

      const coeffColumn = {
        field: "coefficient",
        headerName: `Coeff`,
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 20,
        valueGetter: (params: any) => params.data?.subject?.coefficient ?? "",
        cellRenderer: (record: any) => (
          <div>{record.data?.subject?.coefficient || ""}</div>
        ),
      };

      const creditColumn = {
        field: "subjectueCredit",
        headerName: `Credit`,
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 20,
        valueGetter: (params: any) => params.data?.subject?.credit ?? "",
        cellRenderer: (record: any) => (
          <div>{record.data?.subject?.credit || ""}</div>
        ),
      };

      const validationStatusColumn = {
        field: "validated",
        headerName: `Validé ?`,
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 50,
        valueGetter: (params: any) =>
          params?.data?.average > +10 ? "oui" : "non",
        cellRenderer: (record: any) => {
          // console.log("validated : ", record.data?.average > 10);
          return (
            <div className="text-center">
              <span
                className="badge rounded-pill"
                style={{
                  backgroundColor:
                    record?.data?.average >= 10 ? "#27AE60" : "#E74C3C",
                  color: "#fff",
                  // margin: 2,
                  // borderRadius: 4,
                  // textAlign: "center",
                  // fontWeight: 700,
                  // fontSize: 12,
                }}
              >
                {record?.data?.average >= 10 ? "oui" : "non"}
              </span>
            </div>
          );
        },
      };
      // console.log("all evaluation: ", allEvaluation);
      // On construit les colonnes dynamiques pour chaque évaluation
      const dynamicNotesColumn = allEvaluation?.map(
        (evaluationItem: any, index: number) => ({
          field: `note_${evaluationItem.id}`, // ✅ Doit être une string
          headerName: `${evaluationItem?.label} - ${evaluationItem?.abbreviation}`, // ✅ Texte de l'en-tête
          tooltipField: "weight", // facultatif
          editable: canEdit(permissions, isSuperAdmin), // ✅ rend la cellule éditable
          flex: 1, // colonnes qui s'adaptent à la largeur
          minWidth: 50,
          evaluationId: evaluationItem?.id, // utilisé dans le renderer
          evaluationLevelId: evaluationItem?.id_evaluationlevel,
          cellRenderer: EditableCellRenderer,

          // Facultatif : pour la validation ou transformation
          valueGetter: (params: any) => {
            const noteObj = params?.data?.notes?.find(
              (n: any) =>
                n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
            );
            // console.log("noteObject: ", noteObj);
            return noteObj?.value ?? "";
          },
          valueSetter: (params: any) => {
            const newValue = parseFloat(params.newValue);

            if (
              params.newValue === null ||
              params.newValue === undefined ||
              params.newValue === ""
            ) {
              // Si la nouvelle valeur est null/undefined
              const noteObj = params.data.notes?.find(
                (n: any) =>
                  n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
              );
              if (noteObj) {
                console.log(
                  "Permission delete?: ",
                  permissions.includes(
                    buildPermission(Resource.NOTE, Action.DELETE),
                  ) || isSuperAdmin,
                );
                // La note existe, autoriser la modification (suppression) si permission
                return true;
                // return (
                //   permissions.includes(
                //     buildPermission(Resource.NOTE, Action.DELETE)
                //   ) || isSuperAdmin
                // );
              } else {
                // La note n'existe pas, ne rien faire
                return false;
              }
            } else {
              // Si la nouvelle valeur n'est pas null/undefined, vérifier qu'elle est entre 0 et 20
              if (isNaN(newValue) || newValue < 0 || newValue > 20) {
                toast.error("Veuillez entrer une note valide entre 0 et 20.");
                return false;
              }
            }

            // ✅ met à jour la note dans le bon tableau
            const noteObj = params.data.notes?.find(
              (n: any) =>
                n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
            );

            if (noteObj) {
              if (
                permissions.includes(
                  buildPermission(Resource.NOTE, Action.UPDATE),
                ) ||
                isSuperAdmin
              ) {
                if (newValue !== undefined) noteObj.value = newValue;
                return true;
              }
              // ✅ pemettre la mise à jour dans la base
            } else {
              //permettre de créer une nouvelle note
              if (
                permissions.includes(
                  buildPermission(Resource.NOTE, Action.CREATE),
                ) ||
                isSuperAdmin
              ) {
                return true;
              }
            }
          }, // 🎨 Couleur personnalisée par colonne
          cellStyle: {
            backgroundColor: getColumnColor(index), // ← fonction qui retourne une couleur
          },
        }),
      );
      setColDefs([
        subjectName,
        coeffColumn,
        creditColumn,
        ...dynamicNotesColumn,
        averageColumn,
        validationStatusColumn,
      ]);
    } catch (error: any) {
      console.log(
        "erreur lors de la construction de la table des matières ",
        error,
      );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
      return [];
    }
  };

  // useEffect pour construire les colonnes de matières
  useEffect(() => {
    if (!allEvaluation) return;
    buildSubjectColumn();
  }, [allEvaluation]);

  return (
    <>
      {!studentData ? (
        <div className="card-body h-full">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="mb-3 w-100">
              <div className="my-auto mb-2  flex-nowrap ">
                <h3 className="page-title mb-1">Gestion des Notes</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="#">Éléments Pédagogiques</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/all-notes">All notes</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Notes
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            {/* Barre des tâches - dashboard style (uniformisée avec noteList) */}
            <div className="dashboard-module-menu dashboard-menu-bar align-items-end">
              <div className="dashboard-menu-item">
                <div className="dropdown h-100 dashboard-dropdown">
                  <button
                    className="dashboard-nav-link dashboard-btn dropdown-toggle"
                    type="button"
                    id="studentNoteActionsDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-settings" />
                    <span>Actions</span>
                  </button>
                  <div
                    role="menu"
                    className="dropdown-menu dashboard-dropdown-menu"
                    aria-labelledby="studentNoteActionsDropdown"
                  >
                    <div className="dropdown-item d-flex align-items-center">
                      <ProtectedBtnGenerateReleve
                        isLoading={isLoading}
                        studentId={studentId}
                        selectedPeriod={selectedPeriod}
                        classe={classe}
                        setIsLoading={setIsLoading}
                        generateReleve={generateReleve}
                      />
                    </div>
                    <div className="dropdown-item d-flex align-items-center">
                      <ProtectedBtnGenerateAttestation
                        isCertificateLoading={isCertificateLoading}
                        studentId={studentId}
                        classe={classe}
                        setIsCertificateLoading={setIsCertificateLoading}
                        generateCertificate={generateCertificate}
                        setShowParcours={setShowParcours}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="dashboard-menu-item flex-grow-1" style={{ minWidth: 230 }}>
                <label className="form-label fs-12 mb-1">Niveau / Classe</label>
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <div className="fs-12">Niveau d'étude:</div>
                    <div className="fw-semibold">{classe?.Level?.label}</div>
                  </div>
                  <div>
                    <div className="fs-12">Classe:</div>
                    <div className="fw-semibold">{classe?.label}</div>
                  </div>
                </div>
              </div>

              <div className="dashboard-menu-item flex-grow-1" style={{ minWidth: 220 }}>
                <label className="form-label fs-12 mb-1">Notes de l'étudiant</label>
                <Select
                  showSearch
                  optionFilterProp="label"
                  popupMatchSelectWidth={false}
                  loading={isLoadingStudents}
                  disabled={isLoadingStudents || !classe}
                  style={{ width: "100%" }}
                  placeholder={
                    isLoadingStudents
                      ? "Chargement..."
                      : "Sélectionner un étudiant"
                  }
                  value={
                    studentOptions.some(
                      (option) => option.value === String(studentId),
                    )
                      ? String(studentId)
                      : undefined
                  }
                  onChange={(value) => setStudentId(String(value))}
                  options={studentOptions}
                />
              </div>

              <div className="dashboard-menu-item flex-grow-1" style={{ minWidth: 170 }}>
                <label className="form-label fs-12 mb-1">Période</label>
                <Select
                  showSearch
                  optionFilterProp="label"
                  popupMatchSelectWidth={false}
                  loading={isLoadingPeriods}
                  disabled={isLoadingPeriods || !classe}
                  value={
                    periodOptions.some(
                      (option) => option.value === String(selectedPeriod?.id),
                    )
                      ? String(selectedPeriod.id)
                      : undefined
                  }
                  onChange={(value) => {
                    const selected = allPeriodEvaluation.find(
                      (opt) => String(opt.id) === String(value),
                    );
                    setSelectedPeriod(selected);
                  }}
                  style={{ width: "100%" }}
                  placeholder={
                    isLoadingPeriods
                      ? "Chargement..."
                      : "Sélectionner une période"
                  }
                  options={periodOptions}
                />
              </div>
            </div>
            {!selectedYear?.statut && <InfosAlertYearDisabled />}

            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <StudentNoteStatistique studentNotes={studentNotes} />
              <button type="button" className="btn btn-primary ms-auto" onClick={savePendingChanges} disabled={!pendingChangeCount || isSaving}>
                {isSaving ? <span className="spinner-border spinner-border-sm me-2" /> : <i className="ti ti-device-floppy me-2" />}
                Enregistrer{pendingChangeCount > 0 && ` (${pendingChangeCount})`}
              </button>
            </div>

            {isNotRegisteredInYear ? (
              <div className="alert alert-warning text-dark text-center fs-4" role="alert h-100">
                <i className="ti ti-alert-triangle me-2 text-danger" />
                L'étudiant n'est inscrit dans aucune classe de l'année choisie.
              </div>
            ) : (
              //  Tableau de toutes les matières directement
              <div
                style={{
                  height: "calc(100vh - 200px)",
                  width: "100%",
                  // minHeight: "400px",
                  position: "relative", // wrapper relatif pour overlay
                }}
              >
                {isLoadingGrid && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.85)",
                      zIndex: 20,
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: 48, height: 48 }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>
                      Chargement des données...
                    </div>
                    <div style={{ color: "#6c757d" }}>Veuillez patienter</div>
                  </div>
                )}

                <AgGridReact
                  rowData={studentNotes}
                  columnDefs={colDefs}
                  defaultColDef={defaultColDef}
                  pagination={true}
                  paginationPageSize={50}
                  rowSelection="multiple"
                  // domLayout="normal"
                  gridOptions={{
                    theme: myTheme, // ← ICI ! 👈
                    pagination: true,
                    paginationPageSize: 50,
                  }}
                  // fonction qui gèrer la modificaton des note (celle ci est asynchrone maispas le setValue)
                  onCellValueChanged={(event) => {
                    const { data, colDef, newValue } = event;
                    const customColdef = colDef as CustomColDef;
                    const evaluationId = customColdef.evaluationId;
                    const evaluationLevelId = customColdef.evaluationLevelId;
                    const noteObj = data?.notes?.find(
                      (n: any) =>
                        n.EvaluationLevel?.Evaluation?.id === evaluationId,
                    );
                    const changeKey = `${data?.subject?.id}-${evaluationLevelId}`;

                    if (noteObj) {
                      // Si la note existe et que sa valeur est null ou undefined alors on supprime la note
                      if (
                        newValue === null ||
                        newValue === undefined ||
                        newValue === ""
                      ) {
                        if (noteObj.__pendingCreate) {
                          data.notes = data.notes.filter((note: any) => note !== noteObj);
                          setPendingChanges((current) => {
                            const next = { ...current };
                            delete next[changeKey];
                            return next;
                          });
                          return;
                        }
                        noteObj.value = "";
                        noteObj.__pendingDelete = true;
                        noteObj.__pendingUpdate = false;
                        queueNoteChange(changeKey, { type: "delete", noteId: noteObj.id, payload: {} });
                        return;
                      }

                      if (noteObj.__pendingCreate) {
                        queueNoteChange(changeKey, {
                          type: "create", payload: {
                            id_studentProfil: studentData?.student?.id,
                            id_subjectUE: data?.subject?.id || "",
                            value: newValue, id_evaluationLevel: evaluationLevelId || "",
                          },
                        });
                        return;
                      }
                      noteObj.__pendingUpdate = true;
                      noteObj.__pendingDelete = false;
                      queueNoteChange(changeKey, {
                        type: "update", noteId: noteObj.id, payload: {
                          commentaire: noteObj?.commentaire, value: newValue,
                          id_studentProfil: studentData?.student?.id,
                          id_evaluationLevel: evaluationLevelId, idSubjectUE: data?.subject?.id,
                        },
                      });
                    } else {
                      queueNoteChange(changeKey, {
                        type: "create", payload: {
                          id_studentProfil: studentData?.student?.id,
                          id_subjectUE: data?.subject?.id || "",
                          value: newValue, id_evaluationLevel: evaluationLevelId || "",
                        },
                      });
                      data.notes = data.notes || [];
                      data.notes.push({
                        __pendingCreate: true,
                        value: newValue,
                        id_evaluation: evaluationLevelId || "",
                        EvaluationLevel: {
                          id: evaluationLevelId,
                          Evaluation: { id: evaluationId },
                        },
                      });
                      //   //function pour créer une nouvelle note
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      <ReleveModalApercu
        show={showModal}
        metaData={{
          pdfBlobUrl,
          studentName:
            studentData?.student?.firstname +
            " " +
            studentData?.student?.lastname,
          classLabel: classe?.label,
          periodLabel: selectedPeriod?.label,
          academicYear: selectedYear?.label,
        }}
        onClose={() => setShowModal(false)}
      />

      <CheckStudentEligibilityModal
        show={showParcours}
        onClose={() => setShowParcours(false)}
        metaData={{
          id_studentProfil: studentData?.student?.id,
          studentData,
          classe,
        }}
      />

      <CertificatModalApercu
        show={showModalCertificat}
        metaData={{
          pdfBlobUrl: pdfBlobUrlCertificat,
          studentName:
            studentData?.student?.firstname +
            " " +
            studentData?.student?.lastname,
          selectedParcours: selectedParcours,
          cycleLabel: classe?.Level.cycle,
          periodLabel: selectedPeriod?.label,
          academicYear: selectedYear?.label,
        }}
        onClose={() => setShowModalCertificat(false)}
      />
      <DiplomeModal
        show={showModalDiplome}
        metaData={{
          pdfBlobUrl: pdfBlobUrlDiplome,
          studentName:
            studentData?.student?.firstname +
            " " +
            studentData?.student?.lastname,
          cycleLabel: classe?.Level.cycle,
          periodLabel: selectedPeriod?.label,
          academicYear: selectedYear?.label,
        }}
        onClose={() => setShowModalDiplome(false)}
      />
    </>
  );
};

export default StudentNoteList;
